import { useState } from "react";
import CandidateLight from "./CandidateLight";

const CandidateList = ({ data, langId }) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 4;

  // Calculate the index range to display based on the current page
  const startIdx = (page - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;

  // Slice the data array to show only the items for the current page
  const visibleItems = data.slice(startIdx, endIdx);

  // Calculate the number of pages based on the total number of items
  const numPages = Math.ceil(data.length / itemsPerPage);

  const handlePrevPage = () => {
    setPage((prevPage) => Math.max(1, prevPage - 1));
  };

  const handleNextPage = () => {
    setPage((prevPage) => Math.min(numPages, prevPage + 1));
  };

  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
  };

  const showNavButtons = numPages > 1;

  return (
    <div className="relative h-[370px] mt-4">
      <div className="flex flex-col h-full overflow-x-scroll">
        {visibleItems.map((item, index) => (
          <CandidateLight key={index} item={item} langId={langId} />
        ))}
      </div>
      {showNavButtons && (
        <div className="flex justify-between items-center absolute bottom-0 w-full">
          <button
            className=" px-2 py-1"
            disabled={page === 1}
            onClick={handlePrevPage}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.92">
                <circle
                  cx="24"
                  cy="24"
                  r="24"
                  transform="rotate(-90 24 24)"
                  fill="#F4F4F4"
                />
                <path
                  d="M25.1207 32.9089C25.3622 32.6573 25.4977 32.3169 25.4977 31.9621C25.4977 31.6074 25.3622 31.267 25.1207 31.0154L19.157 24.8511L32.5972 24.8511C32.941 24.8511 33.2708 24.7096 33.5139 24.4578C33.7571 24.2059 33.8936 23.8643 33.8936 23.5081C33.8936 23.152 33.7571 22.8104 33.5139 22.5585C33.2708 22.3067 32.941 22.1652 32.5972 22.1652L19.1959 22.1652L25.1207 16.0278C25.3666 15.7749 25.5054 15.4312 25.5066 15.0723C25.5078 14.7134 25.3713 14.3687 25.1272 14.1141C24.8831 13.8594 24.5513 13.7156 24.2048 13.7144C23.8584 13.7131 23.5256 13.8545 23.2798 14.1074L15.0343 22.6621C14.8166 22.8886 14.6943 23.1952 14.6943 23.5149C14.6943 23.8345 14.8166 24.1411 15.0343 24.3676L23.2798 32.9089C23.4003 33.0348 23.5437 33.1347 23.7017 33.2029C23.8596 33.2711 24.0291 33.3062 24.2002 33.3062C24.3714 33.3062 24.5408 33.2711 24.6988 33.2029C24.8568 33.1347 25.0002 33.0348 25.1207 32.9089Z"
                  fill={page === 1 ? "#C4C4C4" : "#E88B00"}
                  fillOpacity={page === 1 ? 0.2 : 1}
                />
              </g>
            </svg>
          </button>
          <div className="flex">
            {Array.from({ length: numPages }).map((_, idx) => (
              <button
                key={idx}
                className={`h-3 w-3 mx-2 rounded-full ${
                  idx + 1 === page ? "bg-primary" : "bg-gray-200"
                }`}
                onClick={() => handlePageClick(idx + 1)}
              />
            ))}
          </div>
          <button
            className="px-2 my-1 rounded-r"
            disabled={page === numPages}
            onClick={handleNextPage}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="24"
                cy="24"
                r="24"
                transform="rotate(90 24 24)"
                fill="#F4F4F4"
              />
              <path
                d="M22.8793 15.0911C22.6378 15.3427 22.5023 15.6831 22.5023 16.0379C22.5023 16.3926 22.6378 16.733 22.8793 16.9846L28.843 23.1489L15.4028 23.1489C15.059 23.1489 14.7292 23.2904 14.4861 23.5422C14.2429 23.7941 14.1064 24.1357 14.1064 24.4919C14.1064 24.848 14.2429 25.1896 14.4861 25.4415C14.7292 25.6933 15.059 25.8348 15.4028 25.8348L28.8041 25.8348L22.8793 31.9722C22.6334 32.2251 22.4946 32.5688 22.4934 32.9277C22.4922 33.2866 22.6287 33.6313 22.8728 33.8859C23.1169 34.1406 23.4487 34.2844 23.7952 34.2856C24.1416 34.2869 24.4744 34.1455 24.7202 33.8926L32.9657 25.3379C33.1834 25.1114 33.3057 24.8048 33.3057 24.4851C33.3057 24.1655 33.1834 23.8589 32.9657 23.6324L24.7202 15.0911C24.5997 14.9652 24.4563 14.8653 24.2983 14.7971C24.1404 14.7289 23.9709 14.6938 23.7998 14.6938C23.6286 14.6938 23.4592 14.7289 23.3012 14.7971C23.1432 14.8653 22.9998 14.9652 22.8793 15.0911Z"
                fill={page === numPages ? "#C4C4C4" : "#E88B00"}
                fillOpacity={page === numPages ? 0.2 : 1}
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default CandidateList;
